import * as monaco from 'monaco-editor/esm/vs/editor/editor.api';

export const RQL_MONACO_LANGUAGE = {
    defaultToken: '',
    tokenPostfix: '.rql',
    brackets: [
        {open: '[', close: ']', token: 'delimiter.square'},
        {open: '(', close: ')', token: 'delimiter.parenthesis'},
    ],
    keywords: [
        'Any',
        'AND',
        'ASC',
        'BEING',
        'DELETE',
        'DESC',
        'DISTINCT',
        'EXISTS',
        'FALSE',
        'GROUPBY',
        'HAVING',
        'ILIKE',
        'INSERT',
        'LIKE',
        'LIMIT',
        'NOT',
        'NOW',
        'NULL',
        'OFFSET',
        'OR',
        'ORDERBY',
        'SET',
        'TODAY',
        'TRUE',
        'UNION',
        'WHERE',
        'WITH',
        'is',
        'is_instance_of',
    ],
    builtinFunctions: [
        // Aggregate
        'AVG',
        'COUNT',
        'MAX',
        'MIN',
        'SUM',
        'COMMA_JOIN',

        //String transformation
        'UPPER',
        'LOWER',
        'LENGTH',
        'SUBSTRING',
        'LIMIT_SIZE',
        'TEXT_LIMIT_SIZE',

        //Date extraction
        'YEAR',
        'MONTH',
        'DAY',
        'HOUR',
        'MINUTE',
        'SECOND',
        'WEEKDAY',

        //Other
        'ABS',
        'RANDOM',
        'FSPATH',
        'FTIRANK',
        'CAST',
    ],
    tokenizer: {
        root: [
            {include: '@numbers'},
            {include: '@strings'},
            [
                /[A-Z][A-Z0-9_]*(?![a-zA-Z])/,
                {
                    cases: {
                        '@keywords': 'rql.keyword',
                        '@builtinFunctions': 'rql.function',
                        '@default': 'variable',
                    },
                },
            ],
            [
                /[a-z_][a-z0-9_]*/,
                {
                    cases: {
                        '@keywords': 'rql.keyword',
                        '@builtinFunctions': 'rql.function',
                        '@default': 'identifier.relation',
                    },
                },
            ],
            [
                /[A-Z][A-Za-z0-9_]*/,
                {
                    cases: {
                        '@keywords': 'rql.keyword',
                        '@builtinFunctions': 'rql.function',
                        '@default': 'identifier.entity-type',
                    },
                },
            ],
            {include: '@whitespace'},
            [/[<>=!%&+\-*/|~^]/, 'operator'],
            [/[,:;]/, 'delimiter'],
        ],
        whitespace: [[/\s+/, 'white']],
        numbers: [
            [/0[xX][0-9a-fA-F]*/, 'number'],
            [/[$][+-]*\d*(\.\d*)?/, 'number'],
            [/((\d+(\.\d*)?)|(\.\d+))([eE][-+]?\d+)?/, 'number'],
        ],
        strings: [
            [/'$/, 'string.escape', '@popall'],
            [/'/, 'string.escape', '@stringBody'],
            [/"$/, 'string.escape', '@popall'],
            [/"/, 'string.escape', '@dblStringBody'],
        ],
        stringBody: [
            [/[^\\']+$/, 'string', '@popall'],
            [/[^\\']+/, 'string'],
            [/\\./, 'string'],
            [/'/, 'string.escape', '@popall'],
            [/\\$/, 'string'],
        ],
        dblStringBody: [
            [/[^\\"]+$/, 'string', '@popall'],
            [/[^\\"]+/, 'string'],
            [/\\./, 'string'],
            [/"/, 'string.escape', '@popall'],
            [/\\$/, 'string'],
        ],
    },
} as monaco.languages.IMonarchLanguage;
